import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/nextjs/public/pizza-shapes/arch.svg");
;
import(/* webpackMode: "eager" */ "/app/nextjs/public/pizza-shapes/gradient-circle.svg");
